import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Desplaza al inicio de la página
  }, [location]);

  return null; // Este componente no necesita renderizar nada
};

export default ScrollToTop;
